/* eslint-disable no-nested-ternary */

import { useChart } from '@/commons/chart';
import { ColorSchema } from '@/theme/palette';
import { currentFormat } from '@/utils/cases';
import { Box, Card, CardProps, Stack, useTheme } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import { Iconic } from '@/commons/iconic';
import { TITLE } from '@/utils/constants';
import Chart from '../../chart';

interface Props extends CardProps {
  total: number;
  title: string;
  color?: ColorSchema;
  chart: {
    colors?: string;
    series: {
      x: number;
      y: number;
    }[];
    options?: ApexOptions;
  };
  isDiferent?: boolean;
}

export default function BookingTotalIncomes({
  title,
  total,
  color = 'primary',
  chart,
  sx,
  isDiferent,
  ...other
}: Props) {
  const theme = useTheme();

  const {
    colors = [theme.palette[color].main, theme.palette[color].dark],
    series,
    options,
  } = chart;

  const chartOptions = useChart({
    colors: [colors[1]],
    fill: {
      type: 'gradient',
      gradient: {
        colorStops: [
          { offset: 0, color: colors[0], opacity: 1 },
          { offset: 100, color: colors[1], opacity: 1 },
        ],
      },
    },
    chart: {
      sparkline: {
        enabled: true,
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    stroke: {
      width: 4,
    },
    legend: {
      show: false,
    },
    grid: {
      show: false,
    },
    tooltip: {
      marker: {
        show: false,
      },
      y: {
        formatter: () => TITLE,
        title: {
          formatter: () => '',
        },
      },
    },
    ...options,
  });

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        p: 3,
        borderRadius: 2,
        color: `${color}.darker`,
        backgroundColor: 'common.white',
        ...sx,
      }}
      {...other}
    >
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 3 }}>
        <div>
          <Box sx={{ mb: 1, typography: 'subtitle2' }}>{title}</Box>
          <Box sx={{ typography: 'h3' }}>{currentFormat(total)}</Box>
        </div>

        <div>
          <Stack spacing={0.5} direction="row" alignItems="center" justifyContent="flex-end">
            {isDiferent ? (
              <>
                <Iconic
                  icon={
                    total < 0
                      ? 'eva:trending-down-fill'
                      : total === 0
                      ? 'pepicons-pop:minus'
                      : 'eva:trending-up-fill'
                  }
                />
                {/* <Box sx={{ typography: 'subtitle2' }}>
                  {percent > 0 && '+'}
                  {currentFormat(percent)}
                </Box> */}
              </>
            ) : null}
          </Stack>

          {/* <Box sx={{ mt: 0.5, opacity: 0.8, typography: 'body2' }}>than last month </Box> */}
        </div>
      </Stack>

      <Chart type="line" series={[{ data: series }]} options={chartOptions} height={118} />
    </Card>
  );
}
